import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiEndpoint } from "../constants/api";

const RecentJobApplications = ({ employer }) => {
  const [jobApps, setJobApps] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const pageSize = 10; // Number of items per page

  const fetchJobApps = async () => {
    try {
      if (employer) {
        const { data: { data } } = await axios.get(apiEndpoint(`/admin/recent/apps/${employer}`));
        if (data) {
          setJobApps(data);
        }
      }
      
    } catch (err) {
      setError("Failed to load job applications.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch recent job applications from the Fastify endpoint
  useEffect(() => {
    

    fetchJobApps();
  }, [employer]);

  // Calculate the data for the current page
  const indexOfLastApp = currentPage * pageSize;
  const indexOfFirstApp = indexOfLastApp - pageSize;
  const currentApps = jobApps.slice(indexOfFirstApp, indexOfLastApp);

  const totalPages = Math.ceil(jobApps.length / pageSize);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Display a loading spinner
  if (loading) {
    return (
      <div className="flex justify-center items-center h-48">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Display an error message
  if (error) {
    return (
      <div className="text-center text-red-600">
        <p>{error}</p>
      </div>
    );
  }

  // Display a paginated table of recent job applications
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Recent Job Applications</h2>

      {jobApps.length === 0 ? (
        <p className="text-gray-500">No recent job applications.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead className="bg-gray-50">
              <tr>
                <th className="py-2 px-4 text-left text-sm font-medium text-gray-500">Job Title</th>
                <th className="py-2 px-4 text-left text-sm font-medium text-gray-500">Candidate</th>
                <th className="py-2 px-4 text-left text-sm font-medium text-gray-500">App Submitted</th>
                <th className="py-2 px-4 text-left text-sm font-medium text-gray-500">Job Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {currentApps.map((app, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  {/* Job Title linked to /admin/job/${slug} */}
                  <td className="py-2 px-4">
                    <a
                      href={`/admin/job/${app.slug}`}
                      className="text-blue-600 hover:underline"
                    >
                      {app.job_title}
                    </a>
                  </td>
                  {/* Applicant Name linked to /admin/user/${user_id} */}
                  <td className="py-2 px-4">
                    <a
                      href={`/admin/user/${app.user_id}`}
                      className="text-blue-500 hover:underline"
                    >
                      {app.first_name} {app.last_name} ({app.email})
                    </a>
                  </td>
                  {/* Submission Date */}
                  <td className="py-2 px-4">
                    {new Date(app.created_at).toLocaleDateString()}
                  </td>
                  {/* Creation Date */}
                  <td className="py-2 px-4">
                    {new Date(app.job_created_at).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
          <div className="flex justify-between items-center mt-4">
            <button
              className="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded disabled:opacity-50"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <p className="text-sm text-gray-600">
              Page {currentPage} of {totalPages}
            </p>
            <button
              className="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded disabled:opacity-50"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentJobApplications;
